import React from 'react'
import withCategoriesData from '../../Pages/LandingPage/HOcs/withCategoriesData'
import { Link } from 'react-router-dom'

const CategoriesNavbar = ({ categories }) => {
	return (
		<div>
			<div className='mt-6 pt-0'>
				<div className='w-100 bg-product p-2'>
					<nav className='navbar navbar-expand-lg w-100'>
						<div className='container-fluid px-2'>
							<ul className='navbar-nav d-flex flex-row gap-3 text-nowrap overflow-x-auto'>
								{categories.map((category) => (
									<Link
										className='nav-item'
										key={category._id}
										to={`/ProductListingCategories/${category._id}`}
										style={{
											cursor: 'pointer',
											whiteSpace: 'nowrap',
										}}
									>
										<div className='nav-link text-sm fw-bolder text-black'>{category.categoryName}</div>
									</Link>
								))}
							</ul>
						</div>
					</nav>
				</div>
			</div>
		</div>
	)
}

export default withCategoriesData(CategoriesNavbar)
